export const WALLPAPERS = {
  paidia: { bg: "/bg/paidia_v3.jpg", fill: "rgb(188,219,253)" },
  enilikes: { bg: "/bg/enilikes_v3.jpg", fill: "rgb(158,197,199)" },
};

export const wallpaperStyle = (audience) => {
  const w = WALLPAPERS[audience] || WALLPAPERS.paidia;
  return { backgroundImage: `url(${w.bg})`, backgroundSize: "100% auto", backgroundPosition: "top center", backgroundRepeat: "no-repeat", backgroundColor: w.fill };
};

// Pushes page content below the title printed on the wallpaper
export const WALLPAPER_TOP = { paddingTop: "max(10.5vw, 5rem)" };
